"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Stats = void 0;
/**
 * @class to track stats
 */
class Stats {
    constructor() {
        this.eventCounter = 0;
        this.timings = {};
    }
    /**
     * @param {string} name Name of timing stat to track
     * @return {number} id of stat to track
     */
    start(name) {
        this.eventCounter += 1;
        const id = this.eventCounter;
        this.timings[id] = {
            ms: Date.now(),
            name,
        };
        return id;
    }
    /**
     * @param {number} id Id of stat top stop tracking
     * @param {object} [inputMetadata] Metadata to send along with the stat
     * @return {TimingStat}
     */
    stop(id, inputMetadata) {
        var _a, _b;
        const ms = (_a = this.timings[id]) === null || _a === void 0 ? void 0 : _a.ms;
        if (ms == null) {
            return {};
        }
        const metadata = (_b = { ...inputMetadata }) !== null && _b !== void 0 ? _b : {};
        metadata.ms = Date.now() - ms;
        // logger.timing(this.timings[id].name, metadata);
        // TODO add logger
        delete this.timings[id];
        return metadata;
    }
}
exports.Stats = Stats;
//# sourceMappingURL=stats.js.map